"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function About() {
    return (react_1.default.createElement("section", { className: "about", id: "about" },
        react_1.default.createElement("h1", { className: "about--title" }, "ABOUT ME"),
        react_1.default.createElement("p", { className: "about--text" },
            "Hello there. I'm Skylar and I'm a software engineer with 5+ years of experience based in Florida. I focus on web development, primarily with the use React. I hope to continue growing as a developer and utilize my skills to help others.",
            react_1.default.createElement("br", null),
            react_1.default.createElement("br", null),
            " Outside of software development I love to rock climb and cook for people. ")));
}
exports.default = About;
